import React, { useEffect } from "react";
import Link from "next/link";
import dynamic from "next/dynamic";
import Meta from "@components/Meta";
import Entity from "@components/Entity";
import SingleColumnLayout from "@components/Layout/SingleColumnLayout";
import { RenderCategories } from "@components/RenderCategories";
import { logErrorToAPI } from "src/utils/errorLogger";
const AlgoliaSearch = dynamic(() => import("../AlgoliaSearch/AlgoliaSearch"));

const Error = (props) => {
  useEffect(() => {
    // Log the error to our API endpoint only if error is not empty
    if (props?.error && Object.keys(props.error).length > 0) {
      logErrorToAPI(props.error, {
        type: "error-boundary",
        errorId: Date.now().toString(),
      });
    }
  }, [props?.error]);

  return (
    <React.Fragment>
      <Meta
        title="404 Error Page"
        pageType={Entity.ERROR}
        isNewAppRouter={props.isNewAppRouter}
      />
      <div className="errorPageContainer topPadding">
        <div className="width-100 horizontal">
          <h1 className="oppsHead">Oops!</h1>
          <h2 className="subHeading">
            {props.message || "That page is missing"}
          </h2>
        </div>
        <div className="search">
          <span>Try Again</span>
          <AlgoliaSearch classes="errorSearchBox" />
        </div>
        <div className="width-100 bookCategory">
          <RenderCategories />
          <div className="bookContainer">
            <img
              src={`${process.env.S3_IMAGE_URL}/book.png`}
              className="bookImage"
              alt="error"
            />
          </div>

          <p>
            Back to <Link href="/">Home</Link>
          </p>
        </div>
      </div>
      <style>
        {`
          .errorPageContainer {
            width: 50%;
            margin: 1rem;
            overflow: hidden;
          }
          .boldHead {
            font-weight: 600;
          }
          .width-100 {
            display: flex;
            flex-wrap: wrap;
          }
          .width-100.horizontal {
            flex-direction: column;
            text-align: center;
          }
          .width-100.bookCategory {
            justify-content: space-between;
          }
          .width-100.bookCategory .bookContainer,
          .width-100.bookCategory .listContainer {
            flex: 0 0 100%;
            max-width: calc(40% - 10px);
          }
          .width-100.bookCategory .listContainer {
            max-width: calc(60% - 10px);
          }
          .subHeading {
            margin-top: 0px;
            font-size: 16pt;
          }
          .oppsHead {
            font-size: 8rem;
            margin: 15px auto;
          }
          .bookImage {
            width: 90%;
          }
          @media (max-width: 1024px) {
            .errorPageContainer {
              width: 80%;
            }
          }
          @media (max-width: 768px) {
            .errorPageContainer {
              width: 100%;
            }
          }
          @media (max-width: 575px) {
            .width-100 {
              flex-direction: column;
              margin-top: 20px;
            }
            .width-100.bookCategory .bookContainer,
            .width-100.bookCategory .listContainer {
              max-width: 100%;
            }
            .oppsHead {
              font-size: 4rem;
            }
          }
        .errorSearchBox {
          margin: 10px 0;
          width: 90%;
        }
      `}
      </style>
    </React.Fragment>
  );
};
Error.Layout = SingleColumnLayout;
Error.displayName = "error";

export default Error;
